import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { useToast } from '@/components/ui'
import { usersService } from '@/services/http/usersService'

type Props = {
  id: string
  ideaId: string
}

export const useUserInformation = ({ id, ideaId }: Props) => {
  const { toast } = useToast()

  const {
    data: userInformation,
    isError,
    isLoading,
    refetch: refetchUserInformation,
  } = useQuery({
    queryKey: ['userInformation', id],
    queryFn: () => usersService.getInformation(id, ideaId),
  })

  useEffect(() => {
    if (isError)
      toast({
        title: 'Erro ao carregar informações do usuário',
        variant: 'destructive',
      })
  }, [isError, toast])

  if (userInformation) {
    return {
      userInformation,
      isLoading,
      refetchUserInformation,
    }
  }

  return {
    userInformation: null,
    isLoading,
    refetchUserInformation,
  }
}
